module.exports = __webpack_public_path__ + "img/marker_six_blue1.7eff5e9f.png";